module.exports = __webpack_public_path__ + "img/08—01—03—Diagnostic information > WLAN > Additional Debug Information.7362210e.jpg";